// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce .easycommerce-multiselect-input {
    width: 100% !important;
    font-family: "Inter", sans-serif !important;
    font-size: 16px !important;
    font-weight: 400 !important;
    color: var(--color-ec-body) !important;
    border: none !important;
    padding: 0 !important;
    box-shadow: unset !important;
}
.easycommerce .easycommerce-multiselect-input::-moz-placeholder {
    color: var(--color-ec-placeholder) !important;
}
.easycommerce .easycommerce-multiselect-input::placeholder {
    color: var(--color-ec-placeholder) !important;
}
.easycommerce .easycommerce-multiselect-input:focus {
    border: none !important;
    box-shadow: none !important;
    outline: none !important;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/pages/Products/components/common/MultiSelect/style.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,2CAA2C;IAC3C,0BAA0B;IAC1B,2BAA2B;IAC3B,sCAAsC;IACtC,uBAAuB;IACvB,qBAAqB;IACrB,4BAA4B;AAChC;AACA;IACI,6CAA6C;AACjD;AAFA;IACI,6CAA6C;AACjD;AACA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,wBAAwB;AAC5B","sourcesContent":[".easycommerce .easycommerce-multiselect-input {\n    width: 100% !important;\n    font-family: \"Inter\", sans-serif !important;\n    font-size: 16px !important;\n    font-weight: 400 !important;\n    color: var(--color-ec-body) !important;\n    border: none !important;\n    padding: 0 !important;\n    box-shadow: unset !important;\n}\n.easycommerce .easycommerce-multiselect-input::placeholder {\n    color: var(--color-ec-placeholder) !important;\n}\n.easycommerce .easycommerce-multiselect-input:focus {\n    border: none !important;\n    box-shadow: none !important;\n    outline: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
